<template>
<div id="bloc-list-datatable">
    <DataTable :value="blocs" :paginator="true" :rows="5" :totalRecords="blocs.length" responsiveLayout="scroll" @row-click="onRowClick">
        <Column field="libelle" :header="$t('rituals.bloc_list.columns.1')">
            <template #body="slotProps">
                {{ slotProps.data.libelle }}
            </template>
        </Column>
        <Column field="subjects" :header="$t('rituals.bloc_list.columns.2')">
            <template #body="slotProps">
                <div class="flex flex-wrap gap-2">
                    <Chip 
                        v-for="(sujet, index) in slotProps.data.sujets" 
                        :key="index" 
                        :label="sujet.libelle" 
                        class="p-m-1"
                    />
                </div>
            </template>
        </Column>
        <Column style="width:100px">
            <template #body="slotProps">
            <Button
                class="p-button-danger"
                icon="pi pi-trash"
                iconPos="right"
                @click="deleteBloc(slotProps.data.id)"
            />
            </template>
        </Column>
    </DataTable>
</div>
</template>

<script>
import AsTitle from "../Elements/AsTitle.vue";
import DataTable from "primevue/datatable";
import Chip from "primevue/chip";
import Column from "primevue/column";
import Button from "primevue/button";
 
export default {
    name: "BlocList",
    components: {
        AsTitle,
        DataTable,
        Chip,
        Column,
        Button,
    },
    props: {
        blocs: Array,
    },
    emits: ["onRowClick","onDelete"],
    data() {
        return {};
    },
    methods: {
        onRowClick(bloc) {
            this.$emit("onRowClick", bloc.data);
        },
        deleteBloc(blocId) {
            this.$emit("onDelete", blocId);
        },
    },
};
</script>
<style lang="scss">
#bloc-list-datatable {
    .p-datatable-wrapper {
        .p-datatable-tbody tr {
            cursor: pointer;
            transition: background-color 0.2s ease-in-out;
            &:hover {
                background-color: #f5f5f5;
            }
        }
    }
}
</style>